"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractStartParamsModel = function (_Observer) {
    _inherits(ContractStartParamsModel, _Observer);

    /**
     * Tag im Monat, nach Diesem auf den übernächsten Monat gesprungen wird
     * @type {integer}
     */
    function ContractStartParamsModel(observers, id, request) {
        _classCallCheck(this, ContractStartParamsModel);

        var _this = _possibleConstructorReturn(this, (ContractStartParamsModel.__proto__ || Object.getPrototypeOf(ContractStartParamsModel)).call(this, observers, id, request));

        _this.DayBeginAfterNextMonth = 0;
        _this.MonthBeginInFuture = 0;

        _this.ContractStarts = [];
        return _this;
    }

    /**
     * Anzahl der zukünftigen Monate für Vertragsanlage
     * @typeype {integer}
     */


    _createClass(ContractStartParamsModel, [{
        key: "GetContractStartParams",
        value: function GetContractStartParams(clientId) {
            var me = this;
            var reqString = "/ContractsStartParams";
            if (clientId !== null && clientId !== undefined) {
                reqString += "?clientId=" + clientId;
            }

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.DayBeginAfterNextMonth = result.Data.DayBeginAfterNextMonth;
                        me.MonthBeginInFuture = result.Data.MonthBeginInFuture;
                    }
                }
                var id = me.Id ? me.Id : "ContractStartParams";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "GetContractStartParamsByTicketId",
        value: function GetContractStartParamsByTicketId(ticketId, clientId) {
            var me = this;
            if (ticketId !== null && ticketId !== undefined) {
                var reqString = "/Ticket/" + ticketId + "/ContractsStartParams";
                if (clientId !== null && clientId !== undefined) {
                    reqString += "?clientId=" + clientId;
                }

                this.request.setRequest(reqString);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.ContractStarts = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "ContractStartParamsByTicketId";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }, {
        key: "GetContractStartParamsByContractId",
        value: function GetContractStartParamsByContractId(contractId, ticketId, clientId) {
            var me = this;
            if (contractId !== null && contractId !== undefined) {
                var reqString = "/Contracts/" + contractId + "/ContractsStartParams/contractChange";
                var params = [];
                if (ticketId !== null && ticketId !== undefined) {
                    params.push(["ticketId", ticketId]);
                }
                if (clientId !== null && clientId !== undefined) {
                    params.push(["clientId", clientId]);
                }

                if (params.length > 0) {
                    reqString += "?";
                    for (var i = 0; i < params.length; i++) {
                        reqString += params[i][0] + "=" + params[i][1];
                        if (i + 1 < params.length) {
                            reqString += "&";
                        }
                    }
                }
                this.request.setRequest(reqString);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.ContractStarts = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "GetContractStartParamsByContractId";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }]);

    return ContractStartParamsModel;
}(_Observer3.default);

exports.default = ContractStartParamsModel;